import { colors } from '../../colors';
var fiftyFiftyCard = {
  bgColorLight: colors.white,
  bgColorDark: colors.metal,
  textColorDark: colors.metal,
  textColorLight: colors.white
};
export default fiftyFiftyCard;